export enum AccessLevelEnum {
  Read = 'READ',
  Write = 'WRITE',
}
